/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkContainertypeReservationteamCoverageDto } from '../models/work-containertype-reservationteam-coverage-dto';
import { WorkCreateReservationtypeDto } from '../models/work-create-reservationtype-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkReservationtype } from '../models/work-reservationtype';
import { WorkUpdateReservationtypeDto } from '../models/work-update-reservationtype-dto';

@Injectable({ providedIn: 'root' })
export class WorkReservationtypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reservationtypesV2ControllerFindAllPaginated()` */
  static readonly ReservationtypesV2ControllerFindAllPaginatedPath = '/v2/reservationtypes';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationtypesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>containertypeId</li>
     * <li>description</li>
     * <li>durationInMinutes</li>
     * <li>active</li>
     * <li>minDaysInAdvance</li>
     * <li>maxDaysInAdvance</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'description:ASC' | 'description:DESC' | 'durationInMinutes:ASC' | 'durationInMinutes:DESC' | 'active:ASC' | 'active:DESC' | 'minDaysInAdvance:ASC' | 'minDaysInAdvance:DESC' | 'maxDaysInAdvance:ASC' | 'maxDaysInAdvance:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,containertype.name,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>containertype.name</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkReservationtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationtypesV2Service.ReservationtypesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkReservationtype>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationtypesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>containertypeId</li>
     * <li>description</li>
     * <li>durationInMinutes</li>
     * <li>active</li>
     * <li>minDaysInAdvance</li>
     * <li>maxDaysInAdvance</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'description:ASC' | 'description:DESC' | 'durationInMinutes:ASC' | 'durationInMinutes:DESC' | 'active:ASC' | 'active:DESC' | 'minDaysInAdvance:ASC' | 'minDaysInAdvance:DESC' | 'maxDaysInAdvance:ASC' | 'maxDaysInAdvance:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,containertype.name,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>containertype.name</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkReservationtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.reservationtypesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkReservationtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkReservationtype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `reservationtypesV2ControllerCreate()` */
  static readonly ReservationtypesV2ControllerCreatePath = '/v2/reservationtypes';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationtypesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationtypesV2ControllerCreate$Response(
    params: {
      body: WorkCreateReservationtypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservationtype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationtypesV2Service.ReservationtypesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservationtype>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationtypesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationtypesV2ControllerCreate(
    params: {
      body: WorkCreateReservationtypeDto
    },
    context?: HttpContext
  ): Observable<WorkReservationtype> {
    return this.reservationtypesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservationtype>): WorkReservationtype => r.body)
    );
  }

  /** Path part for operation `reservationtypesV2ControllerGetContainertypeReservationteamCoverage()` */
  static readonly ReservationtypesV2ControllerGetContainertypeReservationteamCoveragePath = '/v2/reservationtypes/containertypeReservationteamCoverage';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationtypesV2ControllerGetContainertypeReservationteamCoverage()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerGetContainertypeReservationteamCoverage$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkContainertypeReservationteamCoverageDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationtypesV2Service.ReservationtypesV2ControllerGetContainertypeReservationteamCoveragePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkContainertypeReservationteamCoverageDto>>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationtypesV2ControllerGetContainertypeReservationteamCoverage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerGetContainertypeReservationteamCoverage(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkContainertypeReservationteamCoverageDto>> {
    return this.reservationtypesV2ControllerGetContainertypeReservationteamCoverage$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkContainertypeReservationteamCoverageDto>>): Array<WorkContainertypeReservationteamCoverageDto> => r.body)
    );
  }

  /** Path part for operation `reservationtypesV2ControllerFindOneByContainerTypeId()` */
  static readonly ReservationtypesV2ControllerFindOneByContainerTypeIdPath = '/v2/reservationtypes/byContainerTypeId/{id}';

  /**
   * Required permissions: reservationtypes:read, reservationtypes:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationtypesV2ControllerFindOneByContainerTypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerFindOneByContainerTypeId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservationtype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationtypesV2Service.ReservationtypesV2ControllerFindOneByContainerTypeIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservationtype>;
      })
    );
  }

  /**
   * Required permissions: reservationtypes:read, reservationtypes:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationtypesV2ControllerFindOneByContainerTypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerFindOneByContainerTypeId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkReservationtype> {
    return this.reservationtypesV2ControllerFindOneByContainerTypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservationtype>): WorkReservationtype => r.body)
    );
  }

  /** Path part for operation `reservationtypesV2ControllerFindOneById()` */
  static readonly ReservationtypesV2ControllerFindOneByIdPath = '/v2/reservationtypes/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationtypesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservationtype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationtypesV2Service.ReservationtypesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservationtype>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationtypesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkReservationtype> {
    return this.reservationtypesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservationtype>): WorkReservationtype => r.body)
    );
  }

  /** Path part for operation `reservationtypesV2ControllerDelete()` */
  static readonly ReservationtypesV2ControllerDeletePath = '/v2/reservationtypes/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationtypesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationtypesV2Service.ReservationtypesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationtypesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.reservationtypesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `reservationtypesV2ControllerUpdate()` */
  static readonly ReservationtypesV2ControllerUpdatePath = '/v2/reservationtypes/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationtypesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationtypesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateReservationtypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationtypesV2Service.ReservationtypesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationtypesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationtypesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateReservationtypeDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.reservationtypesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
